module.exports = __webpack_public_path__ + "static/media/rhi_magnesita.771a6a71.svg";